module.exports = __webpack_public_path__ + "img/loading.0e6e0f46.gif";